function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3093",
  "data-name": "Group 3093",
  transform: "translate(824.838 2122.986)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_568",
  "data-name": "Rectangle 568",
  width: 19.156,
  height: 3.324,
  transform: "translate(-805.682 -2119.662) rotate(180)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_569",
  "data-name": "Rectangle 569",
  width: 19.156,
  height: 3.324,
  transform: "translate(-805.682 -2105.457) rotate(180)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3075",
  "data-name": "Group 3075",
  transform: "translate(-824.838 -2115.883)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_570",
  "data-name": "Rectangle 570",
  width: 4.46,
  height: 3.324,
  transform: "translate(19.156 3.324) rotate(180)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_571",
  "data-name": "Rectangle 571",
  width: 4.46,
  height: 3.324,
  transform: "translate(11.808 3.324) rotate(180)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_572",
  "data-name": "Rectangle 572",
  width: 4.46,
  height: 3.324,
  transform: "translate(4.46 3.324) rotate(180)"
})));

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.156,
    height: 17.529,
    viewBox: "0 0 19.156 17.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.34c5c15f.svg";
export { ForwardRef as ReactComponent };